import { useAppDispatch } from '../../../store/hooks/hooks';
import MapButton from '../MapButton/MapButton';
import { ReactComponent as MyLocation } from '../../../res/svg/my-location.svg';
import { updateUserLocation } from '../../../store/slice/mapSlice';
import { useState } from 'react';
import { message, Modal } from 'antd';


function MapLocationButton() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onLocation = () => {
    setLoading(true)
    navigator.geolocation.getCurrentPosition((pos) => {
      setLoading(false)
      dispatch(updateUserLocation({latitud: pos.coords.latitude, longitud: pos.coords.longitude}))
    }, err => {
      if(err.PERMISSION_DENIED) {
        message.error('Debes dar permiso para acceder a tu ubicación.');
      } else {
        message.error('No se ha podido obtener tu ubicación.');
      }
      setLoading(false)
    }, {
      enableHighAccuracy: true,
      maximumAge: 1000 * 60 * 60,
    });
  }


  if (!('geolocation' in navigator)) {
    return null;
  }

  return (
    <MapButton onClick={onLocation}
               icon={MyLocation}
               loading={loading}
               tooltip='Ir a mi ubicación actual.' />
  );
}

export default MapLocationButton;
